import { isEqual } from "lodash";
import { useCallback } from "react";
import { useSelector } from "react-redux";
import * as httpStatus from "http-status-codes";
import { useFetchUserPreferencesQuery } from "store/settings/api";
export const useGetUserPreferences = () => {
    const settings = useSelector((state) => state.settings.current, isEqual);
    const query = useFetchUserPreferencesQuery();
    const forceRefresh = useCallback(() => {
        query.refetch();
    }, [query]);
    const queryState = {
        isFinished: query.isSuccess || query.isError,
        isPending: query.isLoading || query.isFetching,
        status: query.isError ? httpStatus.INTERNAL_SERVER_ERROR : httpStatus.OK
    };
    return [settings, queryState, forceRefresh];
};
